<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/user">Usuários</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Editar usuário</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-body">
                        <form @submit="update">
                            <div class="row mt-2">
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">CPF / CNPJ*</label>
                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" placeholder="Ex: xxx.xxx.xxx-xx"
                                            v-model="user.document" v-mask="['###.###.###-##', '##.###.###/####-##']">
                                    </div>
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Nome*</label>
                                    <input type="text" class="form-control" placeholder="Ex: José da Silva Lima"
                                        v-model="user.name">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">E-mail*</label>
                                    <input type="text" class="form-control" placeholder="Ex: usuario@dominio.com"
                                        v-model="user.email">
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Perfil para acesso*</label>
                                    <multiselect v-model="role_multiselect" :options="roles_options"
                                        :custom-label="roleWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectRole">

                                        <template #noResult>
                                            Nenhum perfil encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                            class="fa fa-save"></i> Atualizar</button>
                                    <router-link to="/category" class="btn btn-danger ml-3"><i class="fa fa-times"></i>
                                        Cancelar</router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import Multiselect from 'vue-multiselect'

export default {
    directives: { mask },
    components: { Loading,Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            role_multiselect: '',
            roles_options: [],
            user: {
                id:'',
                document: '',
                name: '',
                email: '',
                role_id: ''
            },
            enable_error_list:false,
            errors:[]
        }
    },

    computed: {
        isDisabled: function () {
            return this.user.document != '' && this.user.name != '' && this.user.email != '' && this.user.role_id != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.user.id = id;
        const response_roles = this.getRoles();
        response_roles.then(() => {
            this.roles_options = this.roles.map(item => ({
                key: item.id,
                value: item.name
            }));
        });
         this.getUser();
    },
    methods: {
        onCancel() { },
          handleSelectRole(option) {
            this.user.role_id = option.key;
        },
         async getRoles() {
            this.isLoading = true;
            const response = api.get('/rolesAll/listAllNoAdmin')
                .then((response) => {
                    this.roles = response.data.roles;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
                 this.isLoading = false;
            return response;
        },
         roleWithLang({ value }) {
            return value;
        },
        getUser(){
            api.get('/user/'+this.user.id)
                .then((response) => {
                   this.isLoading = false;
                   this.user = response.data.user;
                   this.user.role_id = response.data.user.role_id;
                   this.role_multiselect = { key: response.data.user.role_id, value: response.data.user.role  };
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status,error);
                })
        },
        
        update(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.put('/user/'+this.user.id, this.user)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Usuário atualizado com sucesso!",
                        type: 'success'
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        }
    }
}
</script>

<style lang="scss" scoped></style>